import React, { Component } from "react";
import axios from "axios";
// === UI ===
// import { Text } from "native-base";
import Text from "../components_v2/TextFont";
import {
  Linking,
  Platform,
  StatusBar,
  StyleSheet,
  View,
  Image,
} from "react-native";
import Theme from "../argon-ui/Theme";
import * as Network from "expo-network";
// === Assets ===
import * as CONSTS from "../../assets/consts";
import { translate } from "../locales/translate";
import * as utils from "../util";
// === modules ===
import FirebaseHandler from "../modules/firebaseHandler/FirebaseHandler";
import IPCameraHelper from "../modules/cameraHelper/IPCameraHelper";
import reduxWebsocket from "../modules/socketMiddleWare/socketMiddleWare";
import ServerInfo from "../viewModels/ServerInfo";
// === Redux ===
import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  AppReducer,
  AreaReducer,
  CameraReducer,
  ScenarioReducer,
  DeviceReducer,
  UserReducer,
  ApiReducer,
  AppWidgetReducer,
  UserMessageReducer,
} from "../reducers";
import * as AppActions from "../actions/AppActions";
// === Components ==
import * as SecureStore from "../components_v2/DeviceAsyncStorage";
import ServerList from "../components_v2/Servers/ServerList";
import ModalBase from "../nativeBase-ui/ModalBase";
import { connectToBuilding } from "../hooks/connectToServer/connectToBuilding";
import BuildingInfo from "../viewModels/BuildingInfo";

import { ArButton } from "../argon-ui";
import { faRedo, faServer } from "../../assets/consts/faCharCodes";
import { HStack } from "native-base";

const LOGO_SIZE = 200;
const IS_MOBILE = Platform.OS === "android" || Platform.OS === "ios";

type Props = {
  useBullet: boolean;
  onStore: any;
};
type State = {
  isLoading: boolean;
  errors: string[];
  serverUrl: string | null;
  message: string;
  showRefreshButton: boolean;
  showModal: boolean;
};
// if (Platform.OS != "web") {
//   new FirebaseHandler().setBackgroundMessageHandler();
// }
const doorbellHandler: any = {
  handle: undefined,
};
const AppReducers = combineReducers({
  AppReducer,
  UserReducer,
  AreaReducer,
  CameraReducer,
  ScenarioReducer,
  DeviceReducer,
  // devices

  // sensors

  // api
  ApiReducer,

  // appWidgets
  AppWidgetReducer,

  UserMessageReducer,
});
const rootReducer = (state: any, action: any) => {
  return AppReducers(state, action);
};

class SplashScreen extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // this.socket = null;
    // this.eventListener = null;

    this.state = {
      isLoading: true,
      showRefreshButton: false,
      showModal: false,
      message: translate("splash.searchingNetwork"),
      serverUrl: "",
      errors: ["errors"],
    };
  }
  TLStore: any;
  registerForPushNotification = async () => {
    try {
      var firebaseHandler = new FirebaseHandler();
      firebaseHandler.createDefaultChannels();
      firebaseHandler.registerForPushNotificationListeners();
    } catch (error) {
      console.log("error on App.registerForPushNotification", error);
      this.setState({
        errors: [...this.state.errors, JSON.stringify(error)],
      });
    }
  };
  handleDoorbellNotification = async (notification: any) => {
    let cameraId = undefined;
    if (notification && notification.data && notification.data.cameraId) {
      cameraId = notification.data.cameraId;
    }

    console.log("handling doorbell in App.js with cameraId", cameraId);
    let serverUrl: any = await SecureStore.getItemAsync(CONSTS.SERVER_URL);
    let access_token: any = await SecureStore.getItemAsync(CONSTS.ACCESS_TOKEN);

    var cameraGetInfoUrl = `${serverUrl}Camera/V380Info/${cameraId}`;

    fetch(cameraGetInfoUrl, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    })
      .then((res) => {
        if (res.status == 200) {
          return res.json();
        } else return { status: res.status };
      })
      .then((resj) => {
        if (resj.result && resj.camera) {
          let { cameraId, friendlyName, ip, port, userName, password } =
            resj.camera;

          if (cameraId && ip && port && userName && password) {
            var camHelper = new IPCameraHelper();
            camHelper.play(
              friendlyName,
              ip,
              port,
              cameraId,
              userName,
              password,
              true, // hasDoorLock
              serverUrl,
              access_token
            );
          }
        }
      })
      .catch(console.log);
  };
  findServerAsync = (autoSearch = false) => {
    return new Promise(async (resolve, reject) => {
      if (Platform.OS == "web") {
        Linking.getInitialURL()
          .then((url: any) => {
            // url = "http://ribbon.taplife.ir:3030";
            // url = "http://cloud.taplife.ir:3030";
            // url = "http://192.168.0.30:3030";
            console.log(`initial url`, url);
            if (url) {
              url = url.split("?")[0];
              url = url.replace(/\/app\/?$/g, "");
              httpClient = axios.create();
              httpClient.defaults.timeout = 5000;
              // console.log(`initial url`, url);
              var serverInfo = utils
                .getServerInfo(httpClient, url)
                .then((serverInfo) => {
                  if (serverInfo) {
                    resolve({ serverUrl: url, serverInfo });
                    return;
                  }
                  resolve(null);
                  return;
                })
                .catch(reject);
            }
          })
          .catch(reject);
      } else {
        let networkType = await Network.getNetworkStateAsync();
        if (!networkType.isConnected) {
          this.setState({
            message: translate("splash.noNetworkConnection"),
            showRefreshButton: true,
          });
          resolve(null);
          return;
        }
        // === current Building ===
        var currentBuilding: BuildingInfo | null =
          await SecureStore.Buildings.getCurrentBuilding();
        // === current server ===
        var currentServer: ServerInfo =
          await SecureStore.Servers.getCurrentServer();
        var httpClient = null;
        httpClient = axios.create();
        httpClient.defaults.timeout = 5000;
        // try reconnect to latest stored server
        if (currentBuilding && Object.keys(currentBuilding).length > 0) {
          const serverInfo = await connectToBuilding(
            currentBuilding?.buildingId
          );
          if (serverInfo) {
            resolve({ serverUrl: serverInfo.address, serverInfo });
            return;
          }
        }
        if (currentServer) {
          var serverInfo = await utils.getServerInfo(
            httpClient,
            currentServer.publicAddress
          );
          if (serverInfo) {
            resolve({ serverUrl: currentServer.publicAddress, serverInfo });
            return;
          } else if (this.state.serverUrl) {
            var serverInfo = await utils.getServerInfo(
              httpClient,
              this.state.serverUrl
            );
            if (serverInfo) {
              resolve({ serverUrl: this.state.serverUrl, serverInfo });
              return;
            }
          }
        }
        if (this.state.serverUrl) {
          var serverInfo = await utils.getServerInfo(
            httpClient,
            this.state.serverUrl
          );
          if (serverInfo) {
            resolve({ serverUrl: this.state.serverUrl, serverInfo });
            return;
          }
        }
        if (!autoSearch) {
          console.log("auto search in findServerAsync is off. so return null.");
          resolve(null);
          return;
        }
        resolve(null);
        return;
      }
    });
  };

  initConnection = (autoSearch = false) => {
    var msg = translate("splash.connectingToHub");
    if (this.state.serverUrl) {
      msg += `\r\n ${this.state.serverUrl}`;
    }
    this.setState({
      message: msg,
      showRefreshButton: false,
    });

    this.findServerAsync(autoSearch)
      .then((result: any) => {
        if (result) {
          const { serverUrl, serverInfo } = result;
          if (serverUrl && serverInfo) {
            if (serverUrl == null) {
              this.setState({
                message: translate("splash.hubNotFound"),
                showRefreshButton: true,
              });
              return;
            }
            if (serverUrl && serverInfo) {
              this.setState(
                {
                  serverUrl,
                  message: translate("splash.fetchingData"),
                },
                () => {
                  this.setStore(serverUrl, serverInfo)
                    .then((_serverUrl: any) => {
                      if (_serverUrl && !_serverUrl.endsWith("/")) {
                        _serverUrl += "/";
                      }
                      this.props.onStore &&
                        this.props.onStore(this.TLStore, _serverUrl);
                      SecureStore.setItemAsync(CONSTS.SERVER_URL, _serverUrl);
                    })
                    .catch((e) => console.log("error getStore", serverUrl, e));
                }
              );
              //console.log("server found : ", serverUrl);
            } else {
              this.setState({
                message: translate("splash.hubNotFound"),
                showRefreshButton: true,
              });
            }
          }
        } else {
          this.setState({
            message: translate("splash.hubNotFound"),
            showRefreshButton: true,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        SecureStore.deleteItemAsync(CONSTS.SERVER_URL).catch(console.log);
        Network.getNetworkStateAsync()
          .then((networkType) => {
            if (!networkType.isConnected) {
              this.setState({
                message: translate("splash.noNetworkConnection"),
                showRefreshButton: true,
              });
            } else if (err.code && err.code == "ERR_NETWORK_IP_ADDRESS") {
              this.setState({
                message:
                  translate("splash.hubNotFound") +
                  "\r\n" +
                  translate("splash.ERR_NETWORK_IP_ADDRESS_HINT"),
                showRefreshButton: true,
              });
            } else {
              this.setState({
                message: err.toString(),
                showRefreshButton: true,
              });
            }
          })
          .catch(console.log);
      });
  };

  setStore = async (serverUrl: string, serverInfo: any) => {
    const buildings = await SecureStore.Buildings.getBuildings();
    const currentBuilding = await SecureStore.Buildings.getCurrentBuilding();
    let servers: ServerInfo[] = await SecureStore.Servers.getServers();
    let currentServer = await SecureStore.Servers.getCurrentServer();
    let isMigration = false;
    // === migration Version  ===
    // const setMigrationVersion: number = await SecureStore.setMigrationVersion();
    // console.log("setMigrationVersion out", setMigrationVersion);
    if (
      currentServer &&
      (Object.keys(currentServer).includes(CONSTS.WEBSOCKET_PORT) ||
        Object.keys(currentServer).includes("ports"))
    ) {
      isMigration = true;
      currentServer = utils.renameObjectKey(
        currentServer,
        "websocketPort",
        "ports",
        serverInfo?.ports || serverInfo?.serverInfo?.ports
      );
      // === replace new server with oldServer after change ports ===
      servers?.forEach((element: any) => {
        if (serverInfo.serverId === element.serverId) {
          const newServer = utils.renameObjectKey(
            element,
            "websocketPort",
            "ports",
            serverInfo?.ports || serverInfo?.serverInfo?.ports
          );
          servers[servers.indexOf(element)] = newServer;
        }
      });
    }
    // if (
    //   currentServer &&
    //   this.state.serverUrl !== currentServer.publicAddress &&
    //   this.state.serverUrl !== currentServer.localAddress
    // ) {
    //   currentServer.publicAddress = this.state.serverUrl;
    // }

    return new Promise((resolve, reject) => {
      if (serverUrl) {
        // change schema from http protocol to websocket
        // === websocket port === default SECURE_PORTS
        var websocketUrl = utils.convertHttpToWsUri(
          serverUrl,
          currentServer?.ports
        );
        //  console.log("store with websocket created");
        this.TLStore = createStore(
          rootReducer,
          composeWithDevTools(applyMiddleware(reduxWebsocket(websocketUrl)))
        );
        this.TLStore.dispatch(AppActions.updateServerUrl(serverUrl));
        this.TLStore.dispatch(AppActions.setBuildingList(buildings));
        this.TLStore.dispatch(AppActions.setCurrentBuilding(currentBuilding));
        isMigration
          ? this.TLStore.dispatch(AppActions.setServers(servers))
          : this.TLStore.dispatch(AppActions.setServersList(servers));
        this.TLStore.dispatch(AppActions.updateCurrentServer(currentServer));
        resolve(serverUrl);
      }
      reject();
    });
  };
  async componentDidMount() {
    // if (Platform.OS != "web") {
    //   this.registerForPushNotification();
    //   // this.initLocalNotifications();
    // }
    // doorbellHandler.handle = (notification: any) => {
    //   // console.log("notification", notification);
    //   // console.log("doorbellHandler.handle bind method", notification?.data);
    //   try {
    //     // if (notification) {
    //       this.handleDoorbellNotification(notification)
    //         .then()
    //         .catch((e) => console.log("doorbellHandler error",e));
    //     // }
    //   } catch (e) {
    //     console.log(e);
    //   }
    // };

    this.initConnection();
  }
  // === SplashScreen UI Handler ===
  handleOnRefreshPress = (autoSearch: boolean) => {
    this.initConnection(autoSearch);
  };
  handleOnSettingPress = () => {
    this.setState({ showModal: true });
  };
  handleOnServerChange = (serverInfo: ServerInfo, serverAddress: string) => {
    this.hideModal();
    var serverUrl = serverAddress || serverInfo?.publicAddress || null;
    SecureStore.Servers.addServer(serverInfo).catch((error) => {
      console.log("error add server", error);
    });
    this.setState({ serverUrl }, () => {
      this.initConnection(false);
    });

    //this.handleOnRefreshPress(false);
  };
  hideModal = () => {
    this.setState({ showModal: false });
  };

  render(): React.ReactNode {
    let messages: any = [];
    if (this.state.message) {
      messages = this.state.message.toString().split("\r\n");
    }
    let { useBullet } = this.props;
    if (useBullet === undefined) {
      useBullet = messages.length > 1;
    }
    return (
      <View style={[style.container, { backgroundColor: "#FFF", flex: 1 }]}>
        <StatusBar
          barStyle="light-content"
          backgroundColor={Theme.COLORS.PRIMARY}
          // setBarStyle={Platform.OS === "ios" ? "dark-content" : "light-content"}
        />
        <View
          style={[
            style.container,
            {
              flex: 1,
              width: "100%",
            },
          ]}
        >
          <Image source={CONSTS.BRANDING.LOGO_TYPE} style={style.logo} />
          {messages &&
            messages.length > 0 &&
            messages.map((m: any, i: number) => {
              if (i == 0) {
                return (
                  <Text
                    key={i}
                    style={{
                      marginVertical: 5,
                      textAlign: "center",
                      width: "100%",
                      fontSize: 12,
                      minHeight: 30,
                    }}
                  >
                    {m || ""}
                  </Text>
                );
              }
              return (
                <Text
                  key={i}
                  style={[
                    style.message,
                    {
                      fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif`,
                      fontSize: 12,
                      minHeight: 30,
                    },
                  ]}
                >
                  {useBullet ? "- " : ""}{" "}
                  {m.endsWith("/") ? m.slice(0, -1) : m || ""}
                </Text>
              );
            })}

          {this.state.showRefreshButton && (
            <HStack space="2" mt="3" maxW="md" w="90%">
              <ArButton
                style={{ flex: 1 }}
                iconColor={
                  IS_MOBILE ? Theme.COLORS.PRIMARY : Theme.COLORS.WHITE
                }
                variant={IS_MOBILE ? "outline" : "solid"}
                icon={faRedo}
                underlayColor={Theme.COLORS.THIRED}
                onPress={() => this.handleOnRefreshPress(false)}
              >
                {translate("app.tryAgain")}
              </ArButton>
              {IS_MOBILE && (
                <ArButton
                  style={{ flex: 1 }}
                  icon={faServer}
                  onPress={() => this.handleOnSettingPress()}
                >
                  {translate("serverList.serverList")}
                </ArButton>
              )}
            </HStack>
          )}
        </View>
        {this.state.showModal && (
          <ModalBase
            header={translate("user_profile.serversList")}
            isOpen={this.state.showModal}
            onClose={() => this.hideModal()}
            contentStyle={{ height: "100%" }}
          >
            <ServerList
              onCancel={() => {
                this.setState({ showModal: false });
              }}
              onSelect={(serverInfo, serverAddress) => {
                this.setState({ showModal: false });
                if (serverInfo) {
                  this.handleOnServerChange(serverInfo, serverAddress);
                }
              }}
            />
          </ModalBase>
        )}
      </View>
    );
  }
}
const style = StyleSheet.create({
  container: { justifyContent: "center", alignItems: "center" },
  colorWhite: { color: "#000" },
  firstMessage: {
    color: "#000",
    // paddingVertical: 5,
    // fontWeight: "bold",
    marginVertical: 5,
    alignSelf: "center",
  },
  message: { color: "#000", textAlign: "center" },
  logo: { resizeMode: "contain", width: LOGO_SIZE, height: LOGO_SIZE / 2 },
  btnRefresh: {
    justifyContent: "center",
    alignItems: "center",
    width: 150,
    height: 40,
    borderRadius: 5,
    backgroundColor: Theme.COLORS.PRIMARY,
    marginTop: 8,
    marginHorizontal: 3,
  },
  modalInsideWrapper: {
    backgroundColor: Theme.COLORS.LIGHT_MAIN,
    borderRadius: 15,
    flex: 1,
    margin: 20,
    marginBottom: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    padding: 10,
    paddingTop: 45,
    height: "100%",
  },
});
export default SplashScreen;
